import React from 'react';
import { observer } from 'mobx-react';
import { Link } from 'react-router';

// Translations
import translate from '../Translate.js';

// Dependencies
import { FeatureFlag } from "react-launch-darkly";

// Components
import * as icons from '../Icons/Icons';
import ExamDetailsCompleted from '../Modules/ExamDetailsCompleted';

const ExamCardClosed = observer(class ExamCardClosed extends React.Component {
  startRetake(e) {
    e.preventDefault();

    this.props.store.ScheduleStore.retakeSession(this.props.exam.sid, this.props.exam.examSession.sid, e.target.href);
  }

  renderMessageButton(examSid) {
    const { translation } = this.props;

    return (
      <button
        className="btn btn--inverse--alt"
        onClick={() => {this.props.messageInstructor(examSid)}}
      >
        <icons.iconEnvelope />
        {translation.message_button}
      </button>
    )
  }

  render() {
    const { translation, exam } = this.props;
    const { attemptsRemaining } = exam.examSession.examConfiguration;

    return (
      <article className="panel">
        <header className="panel__header panel__header--closed">
          <h3 className="panel__title">
            {exam.type.toLowerCase() === 'online' &&
              <i className="panel__icn">
                <icons.iconLaptop />
              </i>
            }

            {exam.type.toLowerCase() === 'written' &&
              <i className="panel__icn">
                <icons.iconPencilPaper />
              </i>
            }

            {exam.title} ({translation.closed})
          </h3>

          <div className="panel__tools">
            <FeatureFlag
              flagKey="message-instructor"
              renderFeatureCallback={() => this.renderMessageButton(exam.sid)}
            />
          </div>
        </header>

        <div className="panel__body">
          {attemptsRemaining >= 1 && !this.props.schedulingClosed &&
            <div className="cta">

              {attemptsRemaining > 1 &&
                <strong
                  className="cta__copy"
                >
                  {translation.retake_cta.heading_plural.replace('%remaining%', attemptsRemaining)}
                </strong>
              }

              {attemptsRemaining === 1 &&
                <strong
                  className="cta__copy"
                >
                  {translation.retake_cta.heading.replace('%remaining%', attemptsRemaining)}
                </strong>
              }

              <Link
                className="cta__btn" to={`schedule-session/exam/${exam.sid}/session/${exam.examSession.sid}/configuration/${exam.configuration.sid}`}
                onClick={(e) => {this.startRetake(e)}}
              >
                <icons.iconRefresh className="icon" />
                {translation.retake_cta.button}
              </Link>
            </div>
          }

          <ExamDetailsCompleted {...this.props} />
        </div>
      </article>
    );
  }
})

export default translate('ExamCardClosed')(ExamCardClosed);



// WEBPACK FOOTER //
// ./src/app/components/StudentDashboard/ExamCardClosed.js